import React from 'react';

const MaiaTranslationContext = React.createContext({
  segment: 'FIXTER-UK',
  setSegment: () => {},
  messages: {},
});

export default MaiaTranslationContext;
